<template>
  <TarjetaDatos titulo="Medidas de protección">
    <div class="medidas-proteccion">
      <CampoSwitch classes="mycursor" :checked="poliza.negPuertaBlindada" :disabled="true">Puerta Blindada</CampoSwitch>
      <CampoSwitch :checked="poliza.negRejas" name="Rejas" :disabled="true">Rejas</CampoSwitch>
      <CampoSwitch :checked="poliza.negCristales" name="Cristales de seguridad" :disabled="true">Cristales de seguridad
      </CampoSwitch>
      <CampoSwitch :checked="poliza.negAlarmaSinConexion" name="Alarma sin conexión" :disabled="true">Alarma sin conexión
      </CampoSwitch>
      <CampoSwitch :checked="poliza.negAlarma" name="Alarma con conexión" :disabled="true">Alarma con conexión
      </CampoSwitch>
      <CampoSwitch :checked="poliza.negAntiAlunizaje" name="Medidas anti-alunizaje" :disabled="true">Medidas
        anti-alunizaje
      </CampoSwitch>
      <CampoSwitch :checked="poliza.negVigilancia" name="Vigilancia 24h" :disabled="true">Vigilancia 24h</CampoSwitch>
      <CampoSwitch :checked="poliza.negExtintores" name="Extintores" :disabled="true">Extintores</CampoSwitch>
      <CampoSwitch :checked="poliza.negBIES" name="BIES" :disabled="true">BIES</CampoSwitch>
      <CampoSwitch :checked="poliza.negSprinklers" name="Rociadores" :disabled="true">Rociadores</CampoSwitch>
      <CampoSwitch :checked="poliza.negDetectores" name="Detectores de humo" :disabled="true">Detectores de humo
      </CampoSwitch>
      <Campo2L v-if="poliza.otrasMedidasProteccion" :valor="poliza.otrasMedidasProteccion"
        etiqueta="Otras medidas de proteccion" />
    </div>

  </TarjetaDatos>
</template>

<script>
export default {
  props: {
    poliza: {
      type: Object,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
.medidas-proteccion {
  display: flex;
  flex-direction: column;
  cursor: none;
}
</style>
